export const primaryColor = "#ffc54f";